import { useRef, useState } from 'react';
import SocialLinks from 'components/SocialLinks';
import type { EventData } from 'services/Gtm/entities';
import useClickOutside from 'hooks/useClickOutside';
import * as S from './IconSocialShareDropdownStyles';

interface IconSocialShareDropdownProps {
  title: string;
  trackingData?: EventData;
  className?: string;
}

const IconSocialShareDropdown = ({ title, className = '', trackingData }: IconSocialShareDropdownProps) => {
  const [showSocials, setShowSocials] = useState(false);
  const socialShareRef = useRef(null);
  useClickOutside(socialShareRef, () => setShowSocials(false));

  return (
    <S.IconSocialShareDropdownWrapper
      ref={socialShareRef}
      $showSocials={showSocials}
      onClick={() => setShowSocials(!showSocials)}
      className={className}
    >
      <SocialLinks
        title={title}
        className='social-links-container'
        trackingData={trackingData}
      />
    </S.IconSocialShareDropdownWrapper>
  );
};

export default IconSocialShareDropdown;
